import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../services/alert.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {

    accountId!: string;

    defaultApi!: string;

    deleteAccountVisible!: boolean;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private userService: UserService
    ) {
    }

    ngOnInit() {
        this.route.paramMap.subscribe(
            (params) => {
                let accountId: string | null = params.get('accountId');
                if (accountId && accountId.trim().length > 0) {
                    this.accountId = accountId.trim();
                    this.selectDefaultApi();
                }
            }
        );
    }

    ngOnDestroy() {
    }

    selectDefaultApi() {
        this.progressIndicatorService.progress = true;
        this.userService.getV2LastTokenTimes(this.accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponent.selectDefaultApi.userService.getV2LastTokenTimes.value', value);
                this.progressIndicatorService.progress = false;
                this.defaultApi = !value.lastAccessTokenTime ? 'v1' : 'v2';
            },
            error: (error: any) => {
                console.log('UserComponent.selectDefaultApi.userService.getV2LastTokenTimes.error', error);
                this.progressIndicatorService.progress = false;
                this.defaultApi = 'v1';
            }
        });
    }

    displayDeleteAccount() {
        this.deleteAccountVisible = true;
        setTimeout(() => this.deleteAccountVisible = false, 3000);
    }

    deleteAccount() {
        this.progressIndicatorService.progress = true;
        this.userService.deleteAccountV2(this.accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponent.deleteAccount.userService.deleteAccountV2.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.router.navigate(['/users']);
            },
            error: (error: any) => {
                console.log('UserComponent.deleteAccount.userService.deleteAccountV2.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
